// extracted by mini-css-extract-plugin
export var inner = "modal-module--inner--D8mtl";
export var outer = "modal-module--outer--eVhX0";
export var root = "modal-module--root--fHq-h";
export var scroll = "modal-module--scroll--GHnwn";